import { ThreeDots } from "react-loader-spinner";
import * as theme from "../theme";

const Loader3Orange = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
      }}
    >
      <ThreeDots
        type="ThreeDots"
        color={theme.COLORS.secondary_orange}
        height="100"
        width="100"
      />
    </div>
  );
};

export default Loader3Orange;
